export function isPlainClick(event) {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

export function openInNewTabOnModifiedClick(event, href) {
  if (isPlainClick(event)) return false;
  if (event.button !== 0 && event.button !== 1) return false;
  event.preventDefault();
  window.open(href, '_blank', 'noopener');
  return true;
}
